var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-black-50"},[_c('p',[_vm._v(" © Copyright "+_vm._s(_vm.year)+" - "+_vm._s(_vm.config.appName)+" | "+_vm._s(_vm.config.appDeveloper)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }